import { render, staticRenderFns } from "./passThrough.vue?vue&type=template&id=fc830d3e&scoped=true&"
import script from "./passThrough.vue?vue&type=script&lang=js&"
export * from "./passThrough.vue?vue&type=script&lang=js&"
import style0 from "./passThrough.vue?vue&type=style&index=0&id=fc830d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc830d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
